﻿export function initLanguageDrawer() {
    const drawer = document.querySelector("[data-language-drawer]");
    const toggle = document.querySelector("[data-language-drawer-toggle]");
    const closeButtons = document.querySelectorAll("[data-language-drawer-close]");
    const isRtl = document.documentElement.dir === "rtl";

    if (!drawer || !toggle) return;

    const panel = drawer.querySelector(".language-drawer__panel");

    const getScrollbarWidth = () => {
        return window.innerWidth - document.documentElement.clientWidth;
    };

    const lockScroll = () => {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

        document.documentElement.classList.add("has-language-drawer");
        document.body.classList.add("has-language-drawer");
        document.documentElement.style.setProperty("--scrollbar-compensation", `${scrollbarWidth}px`);
    };

    const unlockScroll = () => {
        document.documentElement.classList.remove("has-language-drawer");
        document.body.classList.remove("has-language-drawer");
        document.documentElement.style.removeProperty("--scrollbar-compensation");
    };

    const openDrawer = () => {
        drawer.hidden = false;
        lockScroll();

        requestAnimationFrame(() => {
            drawer.classList.add("is-open");
        });
    };

    const closeDrawer = () => {
        drawer.classList.remove("is-open");

        setTimeout(() => {
            if (!drawer.classList.contains("is-open")) {
                drawer.hidden = true;
                unlockScroll();
            }
        }, 420);
    };

    toggle.addEventListener("click", () => {
        if (drawer.hidden) {
            openDrawer();
        } else {
            closeDrawer();
        }
    });

    closeButtons.forEach(btn => {
        btn.addEventListener("click", closeDrawer);
    });

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && !drawer.hidden) {
            closeDrawer();
        }
    });

    const magneticItems = drawer.querySelectorAll(".magnetic-item, .magnetic-button");

    magneticItems.forEach(item => {
        item.addEventListener("mousemove", (e) => {
            if (window.innerWidth < 992) return;

            const rect = item.getBoundingClientRect();
            const x = e.clientX - rect.left - rect.width / 2;
            const y = e.clientY - rect.top - rect.height / 2;

            const rtlFactor = isRtl ? -1 : 1;
            item.style.transform = `translate(${x * 0.06 * rtlFactor}px, ${y * 0.06}px)`;
        });

        item.addEventListener("mouseleave", () => {
            item.style.transform = "";
        });
    });

    if (panel) {
        panel.addEventListener("mousemove", (e) => {
            if (window.innerWidth < 992) return;

            const rect = panel.getBoundingClientRect();
            const x = (e.clientX - rect.left - rect.width / 2) / rect.width;
            const y = (e.clientY - rect.top - rect.height / 2) / rect.height;

            const rtlFactor = isRtl ? -1 : 1;
            panel.style.transform = `translateX(0) scale(1) rotateX(${y * -1.2}deg) rotateY(${x * 1.8 * rtlFactor}deg)`;
        });

        panel.addEventListener("mouseleave", () => {
            panel.style.transform = "";
        });
    }
}